module.exports = __webpack_public_path__ + "static/media/Spinner-1s-272px.672ad235.svg";